export default "__VITE_ASSET__L$f4$Uwz__"